import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../../services";
import {
  decryptMessage,
  encryptMessage,
} from "../../services/encryption.decryption";
import dateFormat from "../../utilities/dateFormat";
import toaster from "../../utilities/toaster";

export const getProjectData = createAsyncThunk(
  "PROJECT/getProjectData",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getAllProjectData = createAsyncThunk(
  "PROJECT/getProjects",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postCreateProjectData = createAsyncThunk(
  "PROJECT/createProject",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const putProjectData = createAsyncThunk(
  "UI/updateProject",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const deleteProjectData = createAsyncThunk(
  "PROJECT/deleteProject",
  ({ endPoint }: { endPoint: String }) => {
    return deleteRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getProjectTypeData = createAsyncThunk(
  "PROJECT/getProjectType",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getItemTypeData = createAsyncThunk(
  "PROJECT/getItemType",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getUnitTypeData = createAsyncThunk(
  "PROJECT/getUnitType",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postCreateFinancialData = createAsyncThunk(
  "PROJECT/createFinancial",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getProjectFinancialData = createAsyncThunk(
  "PROJECT/getFinancial",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getProjectFinancialDataByProject = createAsyncThunk(
  "PROJECT/getFinancialByProject",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
//
export const getProjectFinancialDataByProjectIDAndDate = createAsyncThunk(
  "PROJECT/getFinancialByProjectAndDate",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const deleteProjectFinancialData = createAsyncThunk(
  "PROJECT/deletFinancial",
  ({ endPoint }: { endPoint: String }) => {
    return deleteRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const putFinancialData = createAsyncThunk(
  "UI/updateFinancial",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getCompletedProjectData = createAsyncThunk(
  "PROJECT/completed",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

// export const getProjectPhysicalInfo = createAsyncThunk(
//   "PROJECT/getPhysical",
//   ({ endPoint }: { endPoint: String }) => {
//     return getRequest(endPoint)
//       .then((res) => res)
//       .catch((err) => {
//         console.error(err);
//       });
//   }
// );
export const getProjectPhysicalData = createAsyncThunk(
  "PROJECT/get project physical info",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getProjectPhysicalDataByProjectIDAndDate = createAsyncThunk(
  "PROJECT/get project physical data by projectId and Date",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getProjectPilesInfo = createAsyncThunk(
  "PROJECT/get project piles info",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

//------for overall financial details-------------------
export const getOverallFinancialDetails = createAsyncThunk(
  "PROJECT/get overall financial details",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
//-----------for overall monthwise finance data (Table)----------------
export const getOverallMonthlyFinancialDetailsForTable = createAsyncThunk(
  "PROJECT/get overall monthwise financial details for table",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

//-----------for overall monthwise finance data (Graph)----------------
export const getOverallMonthlyFinancialDetails = createAsyncThunk(
  "PROJECT/get overall monthwise financial details for graph",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
//-------------for projectwise financial details (Table)------------
export const getProjectFinancialDetails = createAsyncThunk(
  "PROJECT/get Project financial details",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
//-----------for projectwise financial details (Graph)-----------
export const getProjectFinancialDetailsGraph = createAsyncThunk(
  "PROJECT/get Project financial details for Graph",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
type SliceState = {
  loading: boolean;
  JwtToken: string;
  loginData: null | "" | Object;
  projectData: null | "" | Object;
  createProjectData: null | "" | Object;
  allProjectData: null | "" | Object;
  deleteProjectData: null | "" | Object;
  updateProjectData: null | "" | Object;
  projectTypeData: null | "" | Object;
  unitTypeData: null | "" | Object;
  itemTypeData: null | "" | Object;
  createFinancialData: null | "" | Object;
  getFinancialData: null | "" | Object;
  getFinancialDataByProject: null | "" | Object;
  deleteFinancialData: null | "" | Object;
  updateFinancialData: null | "" | Object;
  completedProjectData: null | "" | Object;
  getPhysicalInfo: null | "" | Object;
  pilesInfo: null | "" | Object;
  overallFinancialData: null | "" | Object;
  overallMonthlyFinancialData: null | "" | Object;
  overallMonthlyFinancialDataTable: null | "" | Object;
  projectFinancialData: null | "" | Object;
  projectFinancialDataGraph: null | "" | Object;
  getFinancialDataByProjectAndDate: null | "" | Object;
  physicalDataByProjectAndDate: null | "" | Object;
};

const initialState: SliceState = {
  loading: false,
  JwtToken: "",
  loginData: "",
  projectData: "",
  createProjectData: "",
  allProjectData: [],
  deleteProjectData: "",
  updateProjectData: "",
  projectTypeData: "",
  unitTypeData: "",
  itemTypeData: [],
  createFinancialData: "",
  getFinancialData: [],
  getFinancialDataByProject: [],
  deleteFinancialData: "",
  updateFinancialData: "",
  completedProjectData: [],
  getPhysicalInfo: [],
  pilesInfo: {
    completedPiles: 0,
    completedDelayPiles: 0,
    wipPiles: 0,
    wipDelayPiles: 0,
    discardRejectPiles: 0,
  },
  overallFinancialData: "",
  overallMonthlyFinancialData: "",
  overallMonthlyFinancialDataTable: "",
  projectFinancialData: "",
  projectFinancialDataGraph: "",
  getFinancialDataByProjectAndDate: "",
  physicalDataByProjectAndDate: "",
};

const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setToken(state, action) {
      state.JwtToken = action.payload;
    },
    clearFinancialData(state) {
      state.getFinancialDataByProjectAndDate = [
        {
          billingDone: 0,
          paymentReceived: 0,
          workDone: 0,
        },
      ];
      state.getFinancialDataByProject = [
        {
          billingDone: 0,
          paymentReceived: 0,
          workDone: 0,
        },
      ];
    },
  },
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getProjectData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjectData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.projectData = data?.data;
      } else {
        console.log(data?.status);
        state.projectData = data?.data;
      }
    });
    builder.addCase(getProjectData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //TODO: Get API CALL START
    builder.addCase(getAllProjectData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllProjectData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.allProjectData = data?.data;
      } else {
        console.log(data?.status);
        state.allProjectData = data?.data;
      }
    });
    builder.addCase(getAllProjectData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Put API CALL START
    builder.addCase(putProjectData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putProjectData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.updateProjectData = data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(putProjectData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END

    //TODO: Post API CALL START
    builder.addCase(postCreateProjectData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postCreateProjectData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));

      if (data?.status) {
        toaster("success", "Project added successfully");
        state.createProjectData = data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(postCreateProjectData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: DEL API CALL START
    builder.addCase(deleteProjectData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteProjectData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.deleteProjectData = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(deleteProjectData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: DEL API CALL END

    //TODO: Get API CALL START
    builder.addCase(getProjectTypeData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjectTypeData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.projectTypeData = data?.data[0]?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getProjectTypeData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getItemTypeData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getItemTypeData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.itemTypeData = data?.data[0]?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getItemTypeData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getUnitTypeData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUnitTypeData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.unitTypeData = data?.data[0]?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getUnitTypeData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Post API CALL START
    builder.addCase(postCreateFinancialData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postCreateFinancialData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));

      console.log("data", data);
      if (data?.status) {
        toaster("success", data?.message);
        state.createFinancialData = data;
      } else {
        toaster("error", data?.stack);
        console.log(data?.status);
      }
    });
    builder.addCase(postCreateFinancialData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: Get API CALL START
    builder.addCase(getProjectFinancialData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjectFinancialData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.getFinancialData = data?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getProjectFinancialData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getProjectFinancialDataByProject.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getProjectFinancialDataByProject.fulfilled,
      (state, action) => {
        state.loading = false;
        const data: any =
          process.env.NODE_ENV === "development"
            ? action.payload?.data
            : decryptMessage(JSON.stringify(action.payload?.data));
        if (data?.status) {
          state.getFinancialDataByProject = data?.data;
        } else {
          console.log(data?.status);
        }
      }
    );
    builder.addCase(getProjectFinancialDataByProject.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

        //TODO: Get API CALL START
        builder.addCase(getProjectFinancialDataByProjectIDAndDate.pending, (state) => {
          state.loading = true;
        });
        builder.addCase(
          getProjectFinancialDataByProjectIDAndDate.fulfilled,
          (state, action) => {
            state.loading = false;
            const data: any =
              process.env.NODE_ENV === "development"
                ? action.payload?.data
                : decryptMessage(JSON.stringify(action.payload?.data));
            if (data?.status) {
              state.getFinancialDataByProjectAndDate = data?.data;
            } else {
              console.log(data?.status);
            }
          }
        );
        builder.addCase(getProjectFinancialDataByProjectIDAndDate.rejected, (state) => {
          state.loading = true;
        });
        //TODO: Get API CALL END

    //TODO: DEL API CALL START
    builder.addCase(deleteProjectFinancialData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteProjectFinancialData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.deleteFinancialData = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(deleteProjectFinancialData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: DEL API CALL END

    //TODO: Put API CALL START
    builder.addCase(putFinancialData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putFinancialData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.updateFinancialData = data;
      } else {
        toaster("error", data?.stack);
      }
    });
    builder.addCase(putFinancialData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END

    //TODO: Put API CALL START
    builder.addCase(getCompletedProjectData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCompletedProjectData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.completedProjectData = data?.data?.data?.map((val: any) => ({
          ...val,
          startDate: dateFormat(val?.startDate?.slice(0, 10)),
          endDate: dateFormat(val?.endDate?.slice(0, 10)),
        }));
      } else {
        toaster("error", data?.message);
      }
    });
    builder.addCase(getCompletedProjectData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END
    //TODO: Get API CALL START
    builder.addCase(getProjectPhysicalData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjectPhysicalData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        const modData: any = {
          titles: data?.data?.titles,
          executedValues: data?.data?.executedValues,
          totalValues:
            data?.data?.totalValues?.workOrderInformation?.workOrderItemDetails?.map(
              (val: any) => ({
                title: val?.name,
                quantity: val?.quantity,
                unit: val?.unit,
              })
            ),
        };
        const tableData: any = modData?.titles?.map((val: any) => {
          const executed: any = modData?.executedValues.filter(
            (item: any) => item?.title === val?.title
          );
          const total: any = modData?.totalValues.find(
            (item: any) => item?.title === val?.title
          );
          const initial= 0;
          return {
            ...val,
            shortName: val?.title
              ?.split(" ")
              .map((val1: any) => val1[0].toUpperCase())
              .join()
              .replaceAll(",", ""),
            executed: executed.length>0 ? executed.map((item:any)=>item.quantity).reduce((preVal:number, currVal:number)=> preVal+currVal, initial

            ) : 0,
            total: total ? total.quantity : 0,
            unit: total ? total.unit : "na",
          };
        });
        state.getPhysicalInfo = tableData;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getProjectPhysicalData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

      //TODO: Get API CALL START
      builder.addCase(getProjectPhysicalDataByProjectIDAndDate.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(getProjectPhysicalDataByProjectIDAndDate.fulfilled, (state, action) => {
        state.loading = false;
        const data: any =
          process.env.NODE_ENV === "development"
            ? action.payload?.data
            : decryptMessage(JSON.stringify(action.payload?.data));
        if (data?.status) {
          const modData: any = {
            titles: data?.data?.titles,
            executedValues: data?.data?.executedValues,
            totalValues:
              data?.data?.totalValues?.workOrderInformation?.workOrderItemDetails?.map(
                (val: any) => ({
                  title: val?.name,
                  quantity: val?.quantity,
                  unit: val?.unit,
                })
              ),
          };
          const tableData: any = modData?.titles?.map((val: any) => {
            const executed: any = modData?.executedValues.filter(
              (item: any) => item?.title === val?.title
            );
            const total: any = modData?.totalValues.find(
              (item: any) => item?.title === val?.title
            );
            const initial= 0;
            return {
              ...val,
              shortName: val?.title
                ?.split(" ")
                .map((val1: any) => val1[0].toUpperCase())
                .join()
                .replaceAll(",", ""),
              executed: executed.length>0 ? executed.map((item:any)=>item.quantity).reduce((preVal:number, currVal:number)=> preVal+currVal, initial
  
              ) : 0,
              total: total ? total.quantity : 0,
              unit: total ? total.unit : "na",
            };
          });
          state.physicalDataByProjectAndDate = tableData;
        } else {
          console.log(data?.status);
        }
      });
      builder.addCase(getProjectPhysicalDataByProjectIDAndDate.rejected, (state) => {
        state.loading = true;
      });
      //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getProjectPilesInfo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjectPilesInfo.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        console.log(data?.data);
        state.pilesInfo = data?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getProjectPilesInfo.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //------------Financial Details for Reports---------------
    //TODO: Get API CALL START
    builder.addCase(getOverallFinancialDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallFinancialDetails.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallFinancialData = data?.data;
      } else {
        console.log(data?.status);
        state.overallFinancialData = data?.data;
      }
    });
    builder.addCase(getOverallFinancialDetails.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
 //----overall monthwise data for table-------------
  //TODO: Get API CALL START
  builder.addCase(getOverallMonthlyFinancialDetailsForTable.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(getOverallMonthlyFinancialDetailsForTable.fulfilled, (state, action) => {
    state.loading = false;
    const data: any =
      process.env.NODE_ENV === "development"
        ? action.payload?.data
        : decryptMessage(JSON.stringify(action.payload?.data));
    if (data?.status) {
      state.overallMonthlyFinancialDataTable = data?.data;
    } else {
      console.log(data?.status);
      state.overallMonthlyFinancialDataTable = data?.data;
    }
  });
  builder.addCase(getOverallMonthlyFinancialDetailsForTable.rejected, (state) => {
    state.loading = true;
  });
  //TODO: Get API CALL END     
  //----------------Overall monthwise finance data for graph---------------
   //TODO: Get API CALL START
   builder.addCase(getOverallMonthlyFinancialDetails.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(getOverallMonthlyFinancialDetails.fulfilled, (state, action) => {
    state.loading = false;
    const data: any =
      process.env.NODE_ENV === "development"
        ? action.payload?.data
        : decryptMessage(JSON.stringify(action.payload?.data));
    if (data?.status) {
      state.overallMonthlyFinancialData = data?.data;
    } else {
      console.log(data?.status);
      state.overallMonthlyFinancialData = data?.data;
    }
  });
  builder.addCase(getOverallMonthlyFinancialDetails.rejected, (state) => {
    state.loading = true;
  });
  //TODO: Get API CALL END  
    //TODO: Get API CALL START
    builder.addCase(getProjectFinancialDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjectFinancialDetails.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.projectFinancialData = data?.data;
      } else {
        console.log(data?.status);
        state.projectFinancialData = data?.data;
      }
    });
    builder.addCase(getProjectFinancialDetails.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
    //-----financial details for Graph---------
    //TODO: Get API CALL START
    builder.addCase(getProjectFinancialDetailsGraph.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProjectFinancialDetailsGraph.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.projectFinancialDataGraph= data?.data;
      } else {
        console.log(data?.status);
        state.projectFinancialDataGraph = data?.data;
      }
    });
    builder.addCase(getProjectFinancialDetailsGraph.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
  },
});

export const uiActions = projectSlice.actions;

export default projectSlice;
